<div class="">
    <div class="">
        <div>
            <div class="maintextContainer">
                <h1>Filter</h1>
                <i class="fa fa-times closebtn" aria-hidden="true" [mat-dialog-close]="true"></i>
            </div>
            <div class="col-md-12">
                <div>
                    <form [formGroup]="counsellingReport">
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class="font-size custom-label">State </mat-label>
                            <mat-select class="form-control" placeholder="Select State" formControlName="StateControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="StateControl2"
                                    class="intbtn" placeholder="Select State">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let class of stateOptions | async" (click)="getcity(class)"
                                    (click)="clearCity()" [value]="class?.stateId">
                                    {{class.stateName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class=" font-size custom-label">City
                            </mat-label>
                            <mat-select class="form-control" placeholder="Select City" formControlName="cityControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="cityControl12"
                                    class="intbtn" placeholder="Select City">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>

                                <mat-option *ngFor="let class of cityOptions | async" (click)="getCampus(class)"
                                    (click)="clearCampus()" [value]="class?.cityId">
                                    {{class.cityName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <mat-checkbox formControlName="noImage">
                                No Building Image
                            </mat-checkbox>
                        </div>

                        <!-- NEW CHECKBOX 2 -->
                        <div class="col-sm-12 mb-3">
                            <mat-checkbox formControlName="noLocation">
                                Latitude / Longitude Empty
                            </mat-checkbox>
                        </div>
                            <div class="col-sm-12 mb-3">
                            <mat-checkbox formControlName="BuildingImage">
                               Building Image
                            </mat-checkbox>
                        </div>
                    </form>
                    <div class="col-lg-12 text-center mt-3">
                        <button type="button" class="applybtn" (click)="getReport()">Get Report</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>